import { getEventTracker } from '@libs/eventTracking'
import {
  getCurrentPagePropertyFor,
  getNextPagePropertyFor,
  NextPagePropertyForInputType,
} from '@libs/eventTracking/eventPropertyUtils'
import { EventNames } from './common'

/**
 * [Link to spec](https://www.dropbox.com/scl/fi/2h3wqwmg0h11i58t295dd/_.paper?dl=0&rlkey=5d0iky4ol057e1czbw5wq0vky#:uid=072262407101007699324762&h2=Sprint-43)
 */

interface TrackUserProfileCollectionListEnterCollectionList {
  toPage: NextPagePropertyForInputType
  postID: string
}

export function trackUserProfileCollectionListEnterCollectionList({
  postID,
  toPage,
}: TrackUserProfileCollectionListEnterCollectionList) {
  getEventTracker().track({
    name: EventNames.USER_PROFILE_COLLECTION_LIST_ENTER_COLLECTION_LIST,
    properties: {
      currentPage: getCurrentPagePropertyFor('user-profile'),
      toPage: getNextPagePropertyFor(toPage),
      actionTarget: postID,
    },
  })
}
